import React from 'react';
import PropTypes from 'prop-types';

import { IMAGES, COPY } from '../constants';
import styles from './fableticsUpgradeVersionTwo.scss';

const PowerWordmark = () => (
    <div className={styles.brandRow}>
        <img src={IMAGES.powerIcon} alt="" className={styles.brandIcon} />
        <span className={styles.brandLabelPower}>POWER</span>
    </div>
);

const TabbedCard = ({ label, children, dataTestid }) => (
    <div className={styles.card} data-testid={dataTestid}>
        <div className={styles.cardHeader}>{label}</div>
        <div className={styles.cardBody}>{children}</div>
    </div>
);

TabbedCard.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    dataTestid: PropTypes.string,
};

TabbedCard.defaultProps = {
    dataTestid: null,
};

const FableticsUpgradeVersionTwo = () => (
    <div
        className={styles.fableticsUpgradeVersionTwo}
        data-testid="fabletics.upgrade-creative.version_two.container"
    >
        <TabbedCard label="PLAY" dataTestid="fabletics.upgrade-creative.version_two.power-card">
            <PowerWordmark />
            <p className={styles.cardCopy}>{COPY.powerCard}</p>
        </TabbedCard>

        <div className={styles.includedGroup}>
            <p
                className={styles.includedSubhead}
                data-testid="fabletics.upgrade-creative.version_two.included-subhead"
            >
                Included with the Annual Plan
            </p>
            <div className={styles.cardStack}>
                <TabbedCard label="STAY" dataTestid="fabletics.upgrade-creative.version_two.gp-card">
                    <img
                        src={IMAGES.gpLogo}
                        alt="Global Privileges"
                        className={`${styles.brandLogo} ${styles.brandLogoGp}`}
                        data-testid="fabletics.upgrade-creative.version_two.gp-card.logo"
                    />
                    <p className={styles.cardCopy}>{COPY.gpCard}</p>
                </TabbedCard>
                <div className={styles.styleGroup}>
                    <TabbedCard
                        label="STYLE"
                        dataTestid="fabletics.upgrade-creative.version_two.fabletics-card"
                    >
                        <img
                            src={IMAGES.fableticsLogo}
                            alt="Fabletics"
                            className={styles.brandLogo}
                            data-testid="fabletics.upgrade-creative.version_two.fabletics-card.logo"
                        />
                        <p className={styles.cardCopy}>{COPY.fableticsCard}</p>
                    </TabbedCard>
                    <p
                        className={styles.zipCaption}
                        data-testid="fabletics.upgrade-creative.version_two.zip-caption"
                    >
                        USA billing ZIP required to access Fabletics.
                    </p>
                </div>
            </div>
        </div>
    </div>
);

export default FableticsUpgradeVersionTwo;
